import styles from './LogerItem.module.css'
import {forwardRef, useImperativeHandle, useState} from "react";
import {ErrorLineItemRef} from "../ErrorLineItem/ErrorLineItem";

export interface ILoggerItem {
    log: (text: string[]) => void;
    clear: ()=>void;
}


interface ILine
{
    line:string
}
interface IProps
{
    lineCount: number
    title?:string
}


const  LoggerItem = forwardRef<ILoggerItem,IProps>(({lineCount,title}:IProps, ref)=> {
    const [lineList, setLineList] = useState<ILine[]>([])
    const [lineCnt, setLineCnt] = useState(lineCount)
    const [val,setVal] = useState("")

    useImperativeHandle(ref, () => ({
        log : log,
        clear: clear
    }));

    const clear = () =>{
        setVal("")
    }
    const log = (text : string[]) =>{
        const xVal = text?.reduce((acc,item)=>{
            acc+=`${item}\n`
            return acc
        },"")
        setVal(xVal)
    }

    return(
        <div className={styles.mainCont}>
            {title &&
                <div className={styles.title}>{title}</div>
            }
            <textarea className={"form-control form-control-sm"}  value={val} rows={lineCnt} readOnly={true}/>
        </div>
    )

})

export default LoggerItem


